import { render, staticRenderFns } from "./EditReader.vue?vue&type=template&id=a56b90f8&"
import script from "./EditReader.vue?vue&type=script&lang=js&"
export * from "./EditReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports